<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="mt-4 pb-2 text-red text-bold">※設定完成後，需等隔日清晨批次更新後才會生效。</div>
        <table class="table table-basic mb-4">
          <tr>
            <th class="w-220">設定人員</th>
            <td>{{ UserInfo.name }}</td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>簡覆表編號</th>
            <td>
              <input
                type="text"
                maxlength="30"
                :id="`div-form_no`"
                :data-vv-name="`div-form_no`"
                placeholder="請輸入簡覆表編號"
                v-validate="'required|checkEngNum'"
                data-vv-as="簡覆表編號"
                class="form-control w-50"
                v-model="form.form_no"
                :class="{ 'is-invalid': errors.has(`div-form_no`) }"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">申請日期</th>
            <td>{{ moment().getROCDate('YYYY/MM/DD') }}</td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>客戶ID</th>
            <td>
              <input
                type="text"
                maxlength="10"
                :id="`div-id`"
                :data-vv-name="`div-id`"
                placeholder="請輸入客戶ID"
                v-validate="'required|checkIDLength'"
                data-vv-as="客戶ID"
                class="form-control w-50"
                v-model="form.id"
                :class="{ 'is-invalid': errors.has(`div-id`) }"
                @input="checkKeyword('id')"
                @blur="checkKeyword('id')"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>設定範圍</th>
            <td>
              <div
                class="radio radio-inline"
                v-for="(single, index) in isScopeRadio"
                :key="`div-setting-scope-${index}`"
              >
                <input
                  type="radio"
                  :id="`div-setting-scope-${index}`"
                  name="div-setting-scope"
                  :value="single.value"
                  v-model="form.in_type"
                  @change="toggleRadio()"
                />
                <label :for="`div-setting-scope-${index}`">{{ single.name }}</label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;" v-if="form.in_type == '1'">*</span>業務員ID</th>
            <td>
              <input
                type="text"
                maxlength="10"
                :id="`div-agnt_id`"
                :data-vv-name="`div-agnt_id`"
                placeholder="請輸入業務員ID"
                v-validate="form.in_type == '1' ? 'required|checkIDLength' : 'checkIDLength'"
                data-vv-as="業務員ID"
                class="form-control w-50"
                v-model="form.agnt_id"
                :class="{ 'is-invalid': errors.has(`div-agnt_id`) }"
                :disabled="form.in_type == '2'"
                @input="checkKeyword('agnt_id')"
                @blur="checkKeyword('agnt_id')"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>原因</th>
            <td>
              <input
                type="text"
                maxlength="30"
                :id="`div-memo`"
                :data-vv-name="`div-memo`"
                placeholder="請輸入原因"
                v-validate="'required'"
                data-vv-as="原因"
                class="form-control w-50"
                v-model="form.memo"
                :class="{ 'is-invalid': errors.has(`div-memo`) }"
              />
            </td>
          </tr>
        </table>
      </div>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doReset(true)">取消</a>
          <a class="btn btn-primary" @click="doSubmit">確定</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '@/mixins/common';
import { Validator } from 'vee-validate';
//component
import mxMask from '@/desktop/components/mxMask';
//service
import { addCustDataViewPermission } from '@/service';
export default {
  name: 'CustDataViewPermissionAdd',
  mixins: [commonMixin],
  components: { mxMask },
  computed: {
    ...mapGetters(['UserInfo'])
  },
  watch: {},
  data() {
    return {
      mxMaskOpen: false,
      mxMaskContent: '資料儲存中，請稍候...',
      form: {
        form_no: '', // 簡覆表編號
        id: '', // 客戶ID
        in_type: '1', // 設定範圍
        agnt_id: '', // 業務員ID
        memo: '', // 原因
      },
      isScopeRadio: [
        {
          name: "特定業務員",
          value: "1"
        },
        {
          name: "全部業務員",
          value: "2"
        }
      ],
    };
  },
  mounted() {
    this.initValidator();
  },
  methods: {
    ...mapActions(['setPageLock']),
    //檢核ID
    checkKeyword(id) {
      if (this.form[id]) {
        this.form[id] = this.form[id].toUpperCase();
        this.form[id] = this.form[id].replace(/[^a-zA-Z0-9]+/g, '');
      }
      if (this.stringBytes(this.form[id], false, 10) > 10) {
        this.form[id] = this.form[id].substring(0, this.stringBytes(this.form[id], true, 10));
      }
    },
    //重設
    doReset(showMsg) {
      this.form = {
        form_no: '', // 簡覆表編號
        id: '', // 客戶ID
        in_type: '1', // 設定範圍
        agnt_id: '', // 業務員ID
        memo: '', // 原因
      };
      if (showMsg) {
        this.$toast.info({ title: '畫面重設成功' });
      }
    },
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
        } else {
          this.callApi();
        }
      });
    },
    callApi() {
      const reqData = {
        form_agnt_id: this.form.agnt_id.trim(), // 業務員ID
        id: this.form.id.trim(), // 客戶ID
        in_type: this.form.in_type, // 設定範圍
        form_no: this.form.form_no.trim(), // 簡覆表編號        
        upd_id: this.UserInfo.id, // 編輯人員ID
        memo: this.form.memo, // 原因
      };
      this.mxMaskOpen = true;
      addCustDataViewPermission(this.UserInfo.id, reqData).then(result => {
        this.mxMaskOpen = false;
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: '客戶資料檢視權限新增成功' });
        } else {
          this.$toast.info({ title: result.header.message });
        }
        this.doReset();
      });

      this.$validator.reset();
    },
    initValidator() {
      // 初始自訂義檢核
      Validator.extend('checkEngNum', {
        getMessage: field => {
          return `${field}不可輸入英文、數字以外內容`;
        },
        validate: value => {
          let isNonEmpty = value.trim().length > 0;
          let isFormatCurrect = /^[a-zA-Z0-9\\]*$/.test(value);
          return isNonEmpty && isFormatCurrect;
        }
      });

      // 初始自訂義檢核
      Validator.extend('checkIDLength', {
        getMessage: field => {
          return `${field}長度不可少於10碼`;
        },
        validate: value => {
          return value.trim().length == 10;
        }
      });
    },
    toggleRadio() {
      if (this.form.in_type == '2') {
        this.form.agnt_id = '';
      }
    }
  }
};
</script>
